module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Falsch abgebogen?","description":"Für den eingegebenen Link konnte keine Seite gefunden werden.","link":"Hier geht\u0027s zurück"},"de":{"title":"Falsch abgebogen?","description":"Für den eingegebenen Link konnte keine Seite gefunden werden.","link":"Hier geht\u0027s zurück"}}')
  delete Component.options._Ctor
}
